import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface States {
  tabIndex: number;
}

const initialState: States = {
  tabIndex: 0,
};

export const settingsSlice = createSlice({
  initialState,
  name: 'settings',
  reducers: {
    setTabIndex: (state, { payload }: PayloadAction<number>) => {
      state.tabIndex = payload;
    },
  },
});

export default settingsSlice.reducer;

export const { setTabIndex: setTabIndexAction } = settingsSlice.actions;
